export default __webpack_public_path__ + "static/media/quiz-q5.b155a2bb.png";